<!-- header-start -->
<header>
    <div class="header-area ">
        <div class="header-top_area d-none d-lg-block">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-4 col-lg-4">
                        <div class="logo">
                            <a routerLink="/home">
                                <img src="../assets/img/logo.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-xl-8 col-md-8">
                        <div class="header_right d-flex align-items-center">
                            <div class="short_contact_list">
                                <ul>
                                    <li>
                                        <a href="mailto:sales@7g.com.au"> <i class="fa fa-envelope"></i> sales@7g.com.au</a>
                                    </li>
                                    <li>
                                        <a href="mailto:support@7g.com.au"> <i class="fa fa-envelope"></i> support@7g.com.au</a>
                                    </li>
                                    <li>
                                        <a routerLink="/contactus"> <i class="fa fa-phone"></i> +61 422 091 443</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="sticky-header" class="main-header-area">
            <div class="container">
                <div class="header_bottom_border">
                    <div class="row align-items-center">
                        <div class="col-12 d-block d-lg-none">
                            <div class="logo">
                                <a routerLink="/home">
                                    <img src="../assets/img/logo.png">
                                </a>
                            </div>
                        </div>
                        <div class="col-xl-9 col-lg-9">
                            <div class="main-menu  d-none d-lg-block">
                                <nav>
                                    <ul id="navigation">
                                        <li><a routerLink="/home">Home</a></li>
                                        <li><a routerLink="/solutions">Solutions <i class="ti-angle-down"></i></a>
                                            <ul class="submenu">
                                                <li><a routerLink="/registryplatform">Registry Platform</a></li>
                                                <li><a routerLink="/onlineapplications">Online Applications</a></li>
                                                <li><a routerLink="/onlineinvestorportal">Online Investor Portal</a></li>
                                            </ul>
                                        </li>
                                        <li><a routerLink="/compliance">Compliance</a></li>
                                        <li><a routerLink="/aboutus">About Us <i class="ti-angle-down"></i></a>
                                            <ul class="submenu">
                                                <li><a routerLink="/testimonials">Testimonials</a></li>
                                            </ul>
                                        </li>
                                        <li><a routerLink="/contactus">Contact Us</a></li>
                                        <li><a routerLink="/demo">Demo</a></li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mobile_menu d-block d-lg-none"></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</header>
<!-- header-end -->